export type ExpirationOptionValue = number | 'custom' | null

export interface ExpirationOption {
  readonly value: ExpirationOptionValue
  readonly label: string
}

export const EXPIRATION_OPTIONS: readonly ExpirationOption[] = [
  { value: 7, label: '7 days' },
  { value: 30, label: '30 days' },
  { value: 90, label: '90 days' },
  { value: 365, label: '1 year' },
  { value: 'custom', label: 'Pick a date' },
  { value: null, label: 'No expiration' },
] as const

export type EnvironmentValue = 'dev' | 'test' | 'live'

export interface EnvironmentOption {
  readonly value: EnvironmentValue
  readonly label: string
}

export const ENVIRONMENT_OPTIONS: readonly EnvironmentOption[] = [
  { value: 'dev', label: 'Development' },
  { value: 'test', label: 'Test' },
  { value: 'live', label: 'Production' },
] as const

export const DEFAULT_ENVIRONMENT: EnvironmentValue = 'dev'
